export enum Color {
  PRIMARY_BLACK = 'primaryBlack',
  SECONDARY_BLACK = 'secondaryBlack',
  TERTIARY_BLACK = 'tertiaryBlack',
  PRIMARY_BLUE = 'primaryBlue',
  SECONDARY_BLUE = 'secondaryBlue',
  PRIMARY_GREEN = 'primaryGreen',
  PRIMARY_GREY = 'primaryGrey',
  SECONDARY_GREY = 'secondaryGrey',
  TERTIARY_GREY = 'tertiaryGrey',
  PRIMARY_ORANGE = 'primaryOrange',
  SECONDARY_ORANGE = 'secondaryOrange',
  PRIMARY_PINK = 'primaryPink',
  SECONDARY_PINK = 'secondaryPink',
  TERTIARY_PINK = 'tertiaryPink',
  PRIMARY_PURPLE = 'primaryPurple',
  SECONDARY_PURPLE = 'secondaryPurple',
  PRIMARY_RED = 'primaryRed',
  PRIMARY_WHITE = 'primaryWhite',
  SECONDARY_WHITE = 'secondaryWhite',
  HOVER_STANDARD = 'hoverStandard',
  HOVER_ALTERNATIVE = 'hoverAlternative',
}
